export const TASK_AVAILABILITY_TYPE = 'availability';
export const TASK_DAY_OFF_TYPE = 'day_off';

export const CALENDAR_DAY_START_HOUR = 7;
export const CALENDAR_DAY_END_HOUR = 21;

export const SLOT_HEIGHT = 32;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/Constants.js